module.exports = __webpack_public_path__ + "img/company_logo.0b9b613c.png";